import parsePhoneNumber from 'libphonenumber-js'


export const ValidatePhone = function (errorMessage: string) {
    // @ts-ignore
    return this.test(`test-telephone-field`, errorMessage, function (value: any) {
        // @ts-ignore
        const { path, createError } = this;
        
        if(!value) {
            return true;
        }

        const phoneNumber = parsePhoneNumber(value);

        if (phoneNumber?.isValid()) {
            return true;
        }

        return (
            createError({ path, message: errorMessage })
        );

    });
}
